import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createStripePortalSession } from '../../api'
import Spinner from '../../components/ui/spinner'

/**
 * Redirects the user to Stripe's Customer Billing Portal.
 * Shows a spinner while creating the portal session.
 */
const BillingPage = () => {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    createStripePortalSession()
      .then((res) => {
        if (cancelled) return
        if (res?.url) {
          window.location.href = res.url
        } else {
          setError('Could not open billing page.')
        }
      })
      .catch((e) => {
        if (!cancelled) setError(e?.message || 'Something went wrong.')
      })
    return () => { cancelled = true }
  }, [])

  if (error) {
    return (
      <div className='d-flex flex-column align-items-center justify-content-center py-5'>
        <p className='text-danger mb-3'>{error}</p>
        <button type='button' className='btn btn-primary' onClick={() => navigate('/dashboard')}>
          Back to dashboard
        </button>
      </div>
    )
  }

  return (
    <div className='d-flex flex-column align-items-center justify-content-center py-5'>
      <Spinner />
      <p className='mt-3 text-muted'>Opening your billing page…</p>
    </div>
  )
}

export default BillingPage
